const MOBILE_WIDTH = 600;
const IPAD_WIDTH = 1024;

export const IS_DESKTOP = window.innerWidth > IPAD_WIDTH;
export const IS_TABLET =
    window.innerWidth <= IPAD_WIDTH && window.innerWidth > MOBILE_WIDTH;

export const IS_MOBILE = window.innerWidth <= MOBILE_WIDTH;
